<style>

</style>

<template>

    <div class="session-calendar">


    </div>

</template>

<script>


export default {
    props: {
        reset_session_id: Number,
    },
    data() {
        return {
            resetSession: {},
            loading: true,
            ready: false,
            //courseSchedules: []
        }
    },
    mounted() {
        this.getResetSession(this.reset_session_id);
    },
    methods: {
        init() {
            this.loading = false;
            this.ready = true;
            this.$root.$emit('course-schedules-loaded');
        },
        getResetSession(resetSessionId) {
            const url = _.replace(this.$root.apiUrls.reset_session.show, 'RESET_SESSION_ID', resetSessionId);
            this.$root.api.get(url).then(response => {
                if (this.checkNoError(response)) {
                    this.resetSession = response.data;
                    this.$store.commit('schedule/course_schedules', response.data.course_schedules);
                    this.init();
                }
            }).catch(e => {
                this.alertApiError(e, this.api);
            });
        },

    },
    computed: {}
}
</script>
